import React from 'react';
import { Loader, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import styles from '../PostPurchaseStep.scss';

interface StorefrontPanelProps {
  previewUrl: string;
  siteUrl?: string;
  isLoading: boolean;
}

export function StorefrontPanel({ previewUrl, siteUrl, isLoading }: StorefrontPanelProps) {
  const { t } = useTranslation();

  return (
    <section className={styles.postPurchasePanel} aria-label={t('post_purchase.storefront.preview_aria')}>
      <div className={styles.postPurchaseBrowserFrame}>
        <div className={styles.postPurchaseBrowserHeader}>
          <div className={styles.postPurchaseBrowserDots} aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <div className={styles.postPurchaseBrowserUrl}>
            {isLoading ? (
              <Loader size="tiny" />
            ) : (
              <Text size="tiny" secondary ellipsis>
                {previewUrl}
              </Text>
            )}
          </div>
          <div className={styles.postPurchaseBrowserSpacer} />
        </div>
        <div className={styles.postPurchaseBrowserContent}>
          {isLoading ? (
            <div
              className={styles.postPurchaseBrowserLoader}
              role="status"
              aria-label={t('post_purchase.storefront.loading_aria')}
            >
              <Loader size="large" />
            </div>
          ) : (
            <iframe
              src={siteUrl}
              title={t('post_purchase.storefront.preview_aria')}
              className={styles.postPurchaseBrowserIframe}
            />
          )}
        </div>
      </div>
    </section>
  );
}
